module.exports = __webpack_public_path__ + "static/media/feature-improvement.8a30864c.png";